export default __webpack_public_path__ + "8b6213046fdc27e4eb74319f9e799702.svg";